import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMRoomUnavailabilityResource {
  
  static postUnavailability(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_unavailabilities.json" + q;  
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static updateUnavailability(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_unavailabilities/" + id + ".json" + q;  
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static deleteUnavailability(id, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_unavailabilities/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
}
export default SMRoomUnavailabilityResource;




// WEBPACK FOOTER //
// ./app/javascript/resources/SMRoomUnavailabilityResource.js